/* istanbul ignore file */
import { useContext, useEffect } from 'react';

import { NavigationContextWithBlock } from './useBlocker.decl';

import type { Blocker, Transition } from 'history';
import noop from 'lodash-es/noop';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

/**
 * Temporary custom implementation since `useBlocker` has been removed from React Router v6
 * but should be reintroduced at some point.
 * https://github.com/remix-run/react-router/commit/256cad70d3fd4500b1abcfea66f3ee622fb90874
 */
export function useBlocker(blocker: Blocker, when = true): void {
  const { navigator } = useContext(NavigationContext) as NavigationContextWithBlock;

  useEffect(() => {
    if (!when) {
      return noop;
    }

    const unblock = navigator.block?.((tx: Transition) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          // Automatically unblock the transition so it can play all the way
          // through before retrying it.
          unblock();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return unblock;
  }, [navigator, blocker, when]);
}
